(ns practitest.frontend.components2.grid.filters
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [format-translation get-translation] :as i18n]
            [practitest.frontend.components.grid.filters :as oldfilters]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.overflow :as overflow]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.components2.grid.common :as gc]
            [practitest.frontend.components2.misc-components :as misc-components]
            [reagent.core :as reagent]
            [practitest.frontend.components2.grid.save-filter-button :as save-filter-button]
            [practitest.frontend.components2.grid.save-filter-modal :as save-filter-modal]))

(defn filter-info-bar [_]
  (let [overflown? (reagent/atom false)
        expanded? (reagent/atom false)
        fallback? (reagent/atom false)
        div-ref (atom nil)
        show-modal? (reagent/atom false)]
    (overflow/resize-callback-lifecycle
      div-ref
      (fn [node]
        (let [new-overflow? (dom/height-overflow? node)]
          ;; Only re-render if overflow state changes here
          (when (not= @overflown? new-overflow?)
            (reset! overflown? new-overflow?))

          ;; Edge case - reset expanded state if no more overflow
          ;; and if there's one row visible only (can happen when we resize
          ;; window to larger size when our filters panel is expanded)
          (when (and @expanded?
                     (not new-overflow?)
                     ;; TODO: keep consistent with CSS styles
                     (<= (.-clientHeight @div-ref) 30))
            (reset! expanded? false))))
      ;; Fallback
      (fn []
        ;; Fallback mode for browsers without ResizeObserver support
        (reset! fallback? true))
      ;; render function
      (fn [{:keys [grid-state
                   local-columns
                   fields
                   show-save-fast-filter?
                   testsets-in-requirement?]
            :as grid-props}]
        (let [autofilters-state (:autofilters-state @grid-state)]
          [:div.data-grid-fast-filters-info
           [icons/mux-grid-filter]
           (if testsets-in-requirement?
             (get-translation "grid.fast-filters.instances-only.label" "Fast Filters (Applies to Instances Only) : ")
             (get-translation "grid.fast-filters.label" "Fast Filters : "))

           (into
             [:div.fast-filters-labels-container
              {:ref #(reset! div-ref %)
               :class (dom/classes-pairs-v :expanded @expanded?
                                           :fallback @fallback?)}]
             (map (fn [[column filter-state]]
                    (let [column-info (first (filter #(= (:field %) column) local-columns))
                          description-fn (oldfilters/filter-description-fn column-info)
                          display-state (if (= (:type column-info) :version_label)
                                          (set (map #(if (vector? %) (last %) %) filter-state))
                                          filter-state)]
                      (when column-info
                        [:span.data-grid-filter-info-badge
                         (str (gc/header-title column-info) ":")

                         (let [text (description-fn display-state)]
                           [overflow/overflow-with-mux-tooltip
                            {}
                            (fn [props]
                              [:span.filter-info-text props text])
                            text])

                         [tooltip/mux-tooltip
                          {}
                          (get-translation "grid.fast-filters.remove-filter-tooltip"
                                           "Remove filter")
                          (fn [props]
                            [:span.remove-filter
                             (assoc props :on-click (fn [_e]
                                                      (swap! grid-state update :autofilters-state dissoc column)
                                                      (oldfilters/on-filter-changed grid-props)))
                             [icons/mux-x-filters]])]]))))
             (seq autofilters-state))

           (when (or @expanded? @overflown?)
             [buttons/button
              {:primary? false

               :icon (if @expanded?
                       [icons/mux-chevron-up2]
                       [icons/mux-chevron-down2])
               :on-click (fn [_e]
                           (swap! expanded? not))}])
           [:div.filter-actions-container
            (when (and (not= (:current-view grid-props) "folders")
                       show-save-fast-filter?)
              [save-filter-button/save-filter-button {:grid-state grid-state :on-open-modal #(reset! show-modal? true)}])

            [misc-components/link-button
             {:class "filter-clear-all"
              :on-click (fn [_e]
                          (swap! grid-state dissoc :autofilters-state)
                          (oldfilters/on-filter-changed grid-props))}
             (get-translation "grid.fast-filters.clear-all-label"
                              "Clear All")]]
           (when show-save-fast-filter?
             [save-filter-modal/save-filter-modal
            {:on-close #(reset! show-modal? false)
             :grid-props grid-props
             :show-modal? show-modal?}])])))))
